import React from 'react';
import { useCurrentUserPermissions } from '../hooks/useSpaceDashboard';

const AccessGate = ({ permissionKey, defaultVal = true, children }) => {
    const { permissions, isLoading } = useCurrentUserPermissions();

    if (isLoading) {
        return null; // Or a generic spinner
    }

    const hasAccess = permissions[permissionKey] ?? defaultVal;

    if (!hasAccess) {
        return (
            <div style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'var(--bg-app)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                color: '#fff',
                fontFamily: 'Inter, sans-serif'
            }}>
                <div style={{
                    background: 'var(--bg-panel)',
                    border: '1px solid rgba(255,255,255,0.05)',
                    borderRadius: '16px',
                    padding: '40px',
                    textAlign: 'center',
                    maxWidth: '400px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.4)'
                }}>
                    <div style={{
                        width: '64px', height: '64px',
                        background: 'rgba(239, 68, 68, 0.1)',
                        color: '#ef4444',
                        borderRadius: '50%',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 24px auto'
                    }}>
                        <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </div>
                    <h2 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '12px' }}>Acceso Denegado</h2>
                    <p style={{ fontSize: '14px', color: '#888', marginBottom: '32px', lineHeight: '1.5' }}>
                        No tienes los permisos necesarios para visualizar esta sección. Solicita acceso a un administrador.
                    </p>
                    <button style={{
                        background: 'var(--accent-primary)',
                        color: '#fff',
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontWeight: 500,
                        cursor: 'pointer',
                        transition: 'opacity 0.2s'
                    }} onMouseOver={(e) => e.target.style.opacity = 0.8} onMouseOut={(e) => e.target.style.opacity = 1}>
                        Solicitar Acceso
                    </button>
                </div>
            </div>
        );
    }

    return children;
};

export default AccessGate;
